// extracted by mini-css-extract-plugin
export default {"extraTextContainer":"KeyConcepts__extraTextContainer___Lm497","innerContainer":"KeyConcepts__innerContainer___Cc2uy"};